<h2 mat-dialog-title>{{ dialogTitle }}</h2>

<mat-dialog-content>
  <br />
  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field appearance="outline">
      <mat-label>Template Name</mat-label>
      <input
        matInput
        formControlName="name"
        cdkFocusInitial
        autocomplete="off"
        />
      @if (form.get('name')?.hasError('required') && form.get('name')?.touched) {
        <mat-error>
          Template name is required
        </mat-error>
      }
    </mat-form-field>
    <br />
    @if(templateType === 'truck') {
      <mat-checkbox formControlName="save_origin">Save Origin</mat-checkbox>
    }
  </form>
  <br />
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="submit()">{{ addButtonLabel }}</button>
  <button mat-button (click)="onNoClick()">Cancel</button>
</mat-dialog-actions>
